import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b4afe61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-5" }
const _hoisted_2 = { class: "card main-table-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Archivos cargados")
], -1))
const _hoisted_4 = { class: "card-body p-0" }
const _hoisted_5 = {
  id: "example1_wrapper",
  class: "dataTables_wrapper dt-bootstrap4"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-12 col-md-12" }
const _hoisted_8 = { class: "form-row justify-content-md-end align-items-md-center align-items-sm-start" }
const _hoisted_9 = { class: "form-group col-auto" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fechaInicial" }, "Fecha inicial", -1))
const _hoisted_11 = { class: "form-group col-auto" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fechaFinal" }, "Fecha final", -1))
const _hoisted_13 = ["min"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-auto mt-4 pt-2 mt-md-0 pt-md-0" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary mt-md-3"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
  ])
], -1))
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-sm-12" }
const _hoisted_17 = { class: "table-responsive table-container" }
const _hoisted_18 = {
  key: 0,
  class: "position-absolute overlay w-100 h-100 mx-auto"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-2x fa-sync-alt fa-spin" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  id: "example1",
  class: "table table-bordered table-striped dataTable dtr-inline mb-0",
  role: "grid",
  "aria-describedby": "example1_info"
}
const _hoisted_22 = { role: "row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "sorting sorting_asc",
  tabindex: "0",
  "aria-controls": "example1",
  rowspan: "1",
  colspan: "1",
  "aria-sort": "ascending",
  "aria-label": "Rendering engine: activate to sort column descending"
}, " Nombre ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "sorting",
  tabindex: "0",
  "aria-controls": "example1",
  rowspan: "1",
  colspan: "1",
  "aria-label": "Browser: activate to sort column ascending"
}, " Estado ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "sorting",
  tabindex: "0",
  "aria-controls": "example1",
  rowspan: "1",
  colspan: "1",
  "aria-label": "Browser: activate to sort column ascending"
}, " Fecha ", -1))
const _hoisted_26 = {
  key: 0,
  class: "sorting",
  tabindex: "0",
  "aria-controls": "example1",
  rowspan: "1",
  colspan: "1",
  "aria-label": "Platform(s): activate to sort column ascending"
}
const _hoisted_27 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_28 = {
  class: "dtr-control sorting_1",
  tabindex: "0"
}
const _hoisted_29 = {
  key: 0,
  class: "text-center"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-eye" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "dtr-control sorting_1",
    tabindex: "0",
    colspan: "4"
  }, /*#__PURE__*/_toDisplayString(`No hay registros`))
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "row mt-2" }
const _hoisted_37 = { class: "col-sm-6" }
const _hoisted_38 = { class: "form-row align-items-center" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-auto my-1" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "ml-2" }, "Registros por página")
], -1))
const _hoisted_40 = { class: "col-auto my-1" }
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "col-sm-6" }
const _hoisted_43 = { class: "ml-2" }

export function render(_ctx, _cache) {
  const _component_pagination = _resolveComponent("pagination")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("form", {
                onSubmit: _cache[4] || (_cache[4] = (...args) => (_ctx.checkDates && _ctx.checkDates(...args)))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.initialDate) = $event)),
                      class: "form-control",
                      id: "fechaInicial",
                      onChange: _cache[1] || (_cache[1] = (...args) => (_ctx.changeInitialDate && _ctx.changeInitialDate(...args)))
                    }, null, 544), [
                      [_vModelText, _ctx.initialDate]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.finalDate) = $event)),
                      class: "form-control",
                      min: _ctx.initialDate,
                      id: "fechaFinal",
                      onChange: _cache[3] || (_cache[3] = (...args) => (_ctx.changeFinalDate && _ctx.changeFinalDate(...args)))
                    }, null, 40, _hoisted_13), [
                      [_vModelText, _ctx.finalDate]
                    ])
                  ]),
                  _hoisted_14
                ])
              ], 32)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                  : _createCommentVNode("", true),
                _createElementVNode("table", _hoisted_21, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_22, [
                      _hoisted_23,
                      _hoisted_24,
                      _hoisted_25,
                      (_ctx.ability.can('VIGIFLOW.VER_DETALLE', 'VIGIFLOW'))
                        ? (_openBlock(), _createElementBlock("th", _hoisted_26, " Acciones "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.files && _ctx.files.length > 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "odd",
                            key: index
                          }, [
                            _createElementVNode("td", _hoisted_28, _toDisplayString(item.nombre), 1),
                            _createElementVNode("td", null, _toDisplayString(item.estado), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.moment(item.fecha_creacion).format("YYYY-MM-DD")), 1),
                            (_ctx.ability.can('VIGIFLOW.VER_DETALLE', 'VIGIFLOW'))
                              ? (_openBlock(), _createElementBlock("td", _hoisted_29, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-outline-primary mx-auto",
                                    onClick: $event => (_ctx.goDetailFile(item.id))
                                  }, _hoisted_32, 8, _hoisted_30)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_33, _hoisted_35))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _withDirectives(_createElementVNode("select", {
                    class: "custom-select mr-sm-2",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.perPage) = $event)),
                    onChange: _cache[6] || (_cache[6] = (...args) => (_ctx.rowsPerPage && _ctx.rowsPerPage(...args)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionPerPage, (option) => {
                      return (_openBlock(), _createElementBlock("option", { value: option }, _toDisplayString(option), 9, _hoisted_41))
                    }), 256))
                  ], 544), [
                    [_vModelSelect, _ctx.perPage]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_pagination, {
                  modelValue: _ctx.page,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.page) = $event)),
                  records: _ctx.records,
                  "per-page": _ctx.perPage,
                  options: _ctx.optionsPaginate,
                  onPaginate: _ctx.getResults
                }, null, 8, ["modelValue", "records", "per-page", "options", "onPaginate"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}